// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__2JQcC"};